const acceptFileType = (file) =>
  file.mime &&
  (file.mime.includes('image') ||
    file.mime.includes('pdf') ||
    file.mime.includes('zip') ||
    file.mime.includes('dcm') ||
    file.mime.includes('dicom'));

export default acceptFileType;
